// src/context/CurrencyContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("$"); // Default to USD

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const countryCode = data.country_code; // e.g., ZA, US
        setCurrency(getCurrencyCode(countryCode));
      })
      .catch((err) => {
        console.error("Error fetching currency:", err);
        setCurrency("$"); // Fallback
      });
  }, []);

  const getCurrencyCode = (countryCode) => {
    const currencyMap = {
      ZA: "R",   // South Africa
      US: "$",   // United States
      GB: "£",   // United Kingdom
      NG: "₦",   // Nigeria
      KE: "KES", // Kenya
      IN: "₹",   // India
    };
    return currencyMap[countryCode] || "$";
  };

  return (
    <CurrencyContext.Provider value={{ currency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

// Custom hook to use currency anywhere
export const useCurrency = () => useContext(CurrencyContext);
